import React from "react";

const MSJ_ERROR_GENERICO = "La confirmación del cargo no se pudo realizar. Por favor intente nuevamente más tarde.";

const esMensajeTecnico = (mensaje) => {
    if (!mensaje || typeof mensaje !== 'string') return false;
    const indicadoresTecnicos = [
        '500 Internal Server Error',
        'subSystemErrors',
        '"code":"500"',
        'Internal Server Error',
        /^\s*\{[\s\S]*"code"[\s\S]*\}/
    ];
    return indicadoresTecnicos.some(ind => 
        typeof ind === 'string' ? mensaje.includes(ind) : ind.test(mensaje)
    );
};

export const MensajeError = (props) => {
    const mensaje = esMensajeTecnico(props.mensajeError) ? MSJ_ERROR_GENERICO : props.mensajeError;
    return (
        <div className={"message-box"} id={"register-error"}>
            <h3>
                <pre style={{ fontFamily: 'inherit', fontSize: 'inherit', color: 'inherit' }}>
                          {mensaje}
                </pre>
            </h3>
        </div>
    )
}